module.exports = __webpack_public_path__ + "img/Logo.88b623fa.png";